// Paso1_Alumno.jsx (MODIFICADO)
import React, { useEffect, useState, useCallback } from 'react';
import { Form, Input, DatePicker, Select, Button, Space, message, Spin } from 'antd';
import moment from 'moment';
import apiClient from '../../../../api/apiClient';
import { getCicloActual } from '../../../../utils/cicloEscolar';
import debounce from 'lodash.debounce'; // ← NUEVO

const { Option } = Select;

const Paso1_Alumno = ({ state, dispatch }) => {
  const { alumno, catalogos } = state;
  const [siguienteCarnet, setSiguienteCarnet] = useState(null);
  
  // NUEVO: Estado para validación de matrícula
  const [matriculaError, setMatriculaError] = useState('');
  const [checkingMatricula, setCheckingMatricula] = useState(false);

  // CARGAR CARNET FUTURO
  useEffect(() => {
    const fetchCarnet = async () => {
      try {
        const res = await apiClient.get('/alumnos/siguiente-carnet');
        const carnet = res.data.siguienteCarnet || res.data.data || res.data;
        setSiguienteCarnet(carnet);
        dispatch({ type: 'SET_SIGUIENTE_CARNET', payload: carnet });
      } catch (error) {
        message.error('Error al cargar carnet');
      }
    };
    fetchCarnet();
  }, []);

  
   // NUEVO: Validar con debounce (espera 600ms sin escribir)
// VALIDAR MATRÍCULA CON DEBOUNCE
  const validarMatriculaDebounced = useCallback(
    debounce(async (matricula) => {
      if (!matricula || matricula.trim() === '') {
        setMatriculaError('');
        setCheckingMatricula(false);
        return;
      }

      setCheckingMatricula(true);

      try {
        const res = await apiClient.get(`/alumnos/existe-matricula?matricula=${encodeURIComponent(matricula.trim())}`);
        if (res.data.existe) {
          setMatriculaError('Esta matrícula ya está registrada');
        } else {
          setMatriculaError('');
        }
      } catch (error) {
        setMatriculaError('Error al verificar matrícula');
      } finally {
        setCheckingMatricula(false);
      }
    }, 1200),
    []
  );
    
    // Llamar al debounce cuando cambie el input
    const handleMatriculaChange = (e) => {
      const val = e.target.value;
      dispatch({ type: 'UPDATE_ALUMNO', payload: { Matricula: val } });
      
      // Cancelar validación anterior si el usuario sigue escribiendo
      validarMatriculaDebounced(val);
    };

  const handleNext = () => {
    if (!alumno.Nombres || !alumno.Apellidos || !alumno.FechaNacimiento || !alumno.Genero || !alumno.IdFamilia) {
      message.error('Complete todos los campos requeridos');
      return;
    }
    if (matriculaError) {
      message.error('Corrija el error de matrícula antes de continuar');
      return;
    }

    dispatch({ type: 'NEXT_STEP' });
  };

  return (
    <Form layout="vertical">
      {/* CARNET FUTURO */}
      {siguienteCarnet && (
        <Form.Item>
          <div style={{ padding: '10px 14px', background: '#e6f7ff', borderRadius: 8, fontWeight: 'bold', color: '#003366' }}>
            El carnet será: <span style={{ color: '#d4380d', fontSize: '18px' }}>{siguienteCarnet}</span>
          </div>
        </Form.Item>
      )}

      {/* MATRÍCULA CON VALIDACIÓN */}
      <Form.Item
        label="Código Mineduc"
        validateStatus={matriculaError ? 'error' : checkingMatricula ? 'validating' : ''}
        help={matriculaError || (checkingMatricula ? 'Verificando...' : '')}
        required
      >
        <Input
          placeholder="Ej: MAT-2025-001"
          value={alumno.Matricula}
          onChange={handleMatriculaChange}  // ← CAMBIO AQUÍ
          addonAfter={checkingMatricula ? <Spin size="small" /> : null}
          style={{ width: '100%' }}
        />
      </Form.Item>

      {/* ... resto del formulario (sin cambios) */}
      <Form.Item label="Nombres" required>
        <Input
          value={alumno.Nombres}
          onChange={(e) => dispatch({ type: 'UPDATE_ALUMNO', payload: { Nombres: e.target.value } })}
        />
      </Form.Item>

      <Form.Item label="Apellidos" required>
        <Input
          value={alumno.Apellidos}
          onChange={(e) => dispatch({ type: 'UPDATE_ALUMNO', payload: { Apellidos: e.target.value } })}
        />
      </Form.Item>

      <Form.Item label="Fecha de Nacimiento" required>
        <DatePicker
          style={{ width: '100%' }}
          value={alumno.FechaNacimiento ? moment(alumno.FechaNacimiento, 'YYYY-MM-DD') : null}
          onChange={(date) => {
            const formatted = date ? date.format('YYYY-MM-DD') : null;
            dispatch({ type: 'UPDATE_ALUMNO', payload: { FechaNacimiento: formatted } });
          }}
          format="DD/MM/YYYY"
          placeholder="DD/MM/AAAA"
          allowClear
        />
      </Form.Item>

      <Form.Item label="Género" required>
        <Select
          placeholder="Seleccione"
          value={alumno.Genero}
          onChange={(value) => dispatch({ type: 'UPDATE_ALUMNO', payload: { Genero: value } })}
        >
          <Option value="M">Masculino</Option>
          <Option value="F">Femenino</Option>
        </Select>
      </Form.Item>

      <Form.Item label="Comunidad Lingüística">
        <Select
          placeholder="Seleccione"
          value={alumno.ComunidadLinguistica}
          onChange={(value) => dispatch({ type: 'UPDATE_ALUMNO', payload: { ComunidadLinguistica: value } })}
        >
          <Option value="Mam">Mam</Option>
          <Option value="Ladino">Ladino</Option>
        </Select>
      </Form.Item>

      <Form.Item label="Familia" required>
        <Space.Compact style={{ width: '100%' }}>
          <Select
            placeholder="Familia seleccionada"
            value={alumno.IdFamilia}
            style={{ width: '80%' }}
            disabled
          >
            <Option value={alumno.IdFamilia}>
              {catalogos.familias.find(f => f.IdFamilia === alumno.IdFamilia)?.NombreFamilia || 'Ninguna'}
            </Option>
          </Select>
          <Button type="primary" onClick={() => dispatch({ type: 'OPEN_MODAL', payload: 'familia' })}>
            Familias
          </Button>
        </Space.Compact>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          size="large"
          onClick={handleNext}
          style={{ width: '100%' }}
          disabled={checkingMatricula}  // ← Solo spinner, no error
        >
          Siguiente
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Paso1_Alumno;